import type { App } from "@/models";
import { get as apiGet } from "./API";

export async function get(): Promise<App> {
  return apiGet("location");
}
